import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import LoadingLocked from '@automation/core/components/loading-locked';
import { useSnackbar } from 'notistack';
import Breadcrumbs from '../../common/components/Breadcrumbs/Brreadcrumbs';
import s from './JobDescription.css';
import Description from './Description/Description';

export default function JobDescriptionPresentation({ breadcrumbLinks, jobData, isMobile, jobId, isPageLoading, isError }) {
  useStyles(s);
  const { enqueueSnackbar } = useSnackbar();

  if (isError) {
    enqueueSnackbar('خطا در دریافت اطلاعات', { variant: 'error' });
  }
  return (
    <div className={`${s.jobDescriptionContainer} ${jobData?.locale === 'EN' ? s.english : ''}`}>
      {!isPageLoading && jobData && !isError ? (
        <div className={s.jobDescription}>
          <Breadcrumbs links={breadcrumbLinks} className={s.breadcrumbs} />
          <Description jobDescription={jobData} isMobile={isMobile} jobId={jobId} />
        </div>
      ) : (
        <LoadingLocked />
      )}
    </div>
  );
}

JobDescriptionPresentation.propTypes = {
  jobId: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  breadcrumbLinks: PropTypes.array.isRequired,
  jobData: PropTypes.object.isRequired,
};
